import {openDb} from "../../../Services/BrowserDatabaseIDB";
import {ensureStoresExist, mergeChanged} from "../../../Services/BrowserDatabaseFunctions";

export function addEventMessage(_event_id, _message) {
    return openDb("pa", 1, ensureStoresExist)
        .then(function (db) {
            const tx = db.transaction("Events", "readwrite");
            const dataStore = tx.objectStore("Events");

            // 1. Fetch the event
            return dataStore.get(_event_id).then(event => {
                if (!event) {
                    console.error(`Event with ID ${_event_id} not found.`);
                    return false;
                }

                // 2. Ensure messages is an array
                const messages = Array.isArray(event.messages)
                    ? event.messages.slice()
                    : [];

                // 3. Finding Logic: Check for real ID OR the temporary ID tracker
                const idx = messages.findIndex(m => {
                    if (!m || !_message) return false;

                    // Match by permanent ID
                    const idMatch = m.id && _message.id && String(m.id) === String(_message.id);

                    // Match by temporary ID (crucial for Optimistic UI swap)
                    const tempIdMatch = m.temp_id && _message.temp_id && String(m.temp_id) === String(_message.temp_id);

                    return idMatch || tempIdMatch;
                });

                if (idx >= 0) {
                    // 4. Update/Confirm Logic: Swap the optimistic placeholder with server truth
                    const base = messages[idx];
                    const patch = _message;

                    // We merge fields, but prioritize the server's version (the patch)
                    const merged = { ...base };
                    Object.keys(patch).forEach(k => {
                        if (typeof patch[k] !== "undefined") merged[k] = patch[k];
                    });

                    messages[idx] = merged;
                } else {
                    // 5. Addition Logic: New message from someone else
                    messages.push(_message);
                }

                // 6. Write back
                event.messages = messages;

                // Standard cleanup and save
                const sanitizedEvent = JSON.parse(JSON.stringify(event));

                return dataStore.put(sanitizedEvent).then(() => {
                    console.log(
                        `Message ${(_message.id || _message.temp_id)} in Event ${_event_id} synced locally.`
                    );
                    return true;
                });
            });
        })
        .catch(function (error) {
            console.error("An error occurred in addEventMessage:", error);
            throw error;
        });
}